import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const Heading = ({ size, className, withIndent, children }) => {
	return React.createElement(`h${size}`, {
		className: classNames(className, {
			'with-indent': withIndent
		})
	}, children)
}

Heading.propTypes = {
	size: PropTypes.number,
	className: PropTypes.string,
	withIndent: PropTypes.bool
};

Heading.defaultProps = {
	size: 1
};

export default Heading;
